export const APP_LANGUAGE = 'app_language'
export const POINT_GROUPE_SALES_INFO = 'POINT_GROUPE_SALES_INFO'